module.exports = __webpack_public_path__ + "static/ART_Logo-usage_correct1-f3144e922cb7a295e96e296c3138a014.svg";